export enum UserProfileEnum {
  USER = "Usuário",
  ADMIN = "Administrador",
  ACCESS_ADMIN = "Administrador de acesso",
  MANAGER = "Gestor de acessos",
  VC = "Responsável pelo contrato",
  USER_EN = "USER",
  MANAGER_EN = "MANAGER",
  VC_EN = "VC",
  SYSTEMIC = "Sistêmico",
}

export const UserProfileDescription: Partial<Record<UserProfileEnum, string>> ={
  [UserProfileEnum.USER]: 'Possui acesso apenas aos produtos disponíveis em sua conta.',
  [UserProfileEnum.ACCESS_ADMIN]: 'Apoia na administração dos acessos de forma rápida aqui no Portal de Logons.',
  [UserProfileEnum.MANAGER]: 'Indicado pelo Responsável pelo contrato, gerencia os acessos e solicita alterações contratuais, financeiras e cadastrais. ',
  [UserProfileEnum.VC]: 'É quem assinou o contrato. Gerencia os acessos e solicita alterações contratuais, financeiras e cadastrais.',
  [UserProfileEnum.SYSTEMIC]: 'Conta usada por integrações automatizadas (acesso via API).'
}